import { render, staticRenderFns } from "./RespostaTextarea.vue?vue&type=template&id=5878260f&scoped=true"
import script from "./RespostaTextarea.vue?vue&type=script&lang=js"
export * from "./RespostaTextarea.vue?vue&type=script&lang=js"
import style0 from "./RespostaTextarea.vue?vue&type=style&index=0&id=5878260f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5878260f",
  null
  
)

export default component.exports